import createAxiosInstance from "./LambdaApiCierreDia";

export async function fetchFormasPagoAdd(body, accessToken) {
  const axiosInstance = await createAxiosInstance();
  const requestConfig = {
    method: "POST", // Cambia el método si es necesario
    url: "/reclasificacion/available-fields",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    data: body,
  };
  return axiosInstance(requestConfig);
}
